"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _logger = _interopRequireDefault(require("./logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var logger = new _logger.default('service:websocketManager');
class Lock {
  constructor() {
    this.isLocked = false;
    this.queue = [];
  }
  acquire() {
    return new Promise(resolve => {
      var attempt = () => {
        if (!this.isLocked) {
          this.isLocked = true;
          resolve(this.release.bind(this));
        } else {
          logger.warn('Queuing stuff, process it after previous is done');
          this.queue.push(attempt);
        }
      };
      attempt();
    });
  }
  release() {
    this.isLocked = false;
    if (this.queue.length > 0) {
      logger.log('Unqueue stuff, processing');
      var next = this.queue.shift();
      next();
    }
  }
}
exports.default = Lock;
module.exports = exports.default;